import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { debounceTime, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ManufacturerService {

constructor(private http: HttpClient) { }

  baseUrl = environment.apiUrl;
  // baseUrl = 'https://ohssdsapidev.azurewebsites.net/api/v1/';
  // baseUrl = 'https://ohssandboxqa.healthcarebc.ca/sdsapi/api/v1/';
  // baseUrl: 'https://sds.healthcarebc.ca/sdsapi/api/v1/';

manufacturerInformation() {
  return this.http.get(this.baseUrl + `manufacturers/Manufacturer`);
}

findManufacturers(model: any) {
  let tokenString = '';
    const securityToken: string = localStorage.getItem('token');
    let httpHeaders = new HttpHeaders();
    if (securityToken != null) {
      tokenString = `Bearer ${securityToken}`;
      httpHeaders = new HttpHeaders()
        .set('authorization', tokenString)
        .set('Content-Type', 'application/json');
    } else {
      httpHeaders = new HttpHeaders()
        .set('Content-Type', 'application/json');
    }
  return this.http.post(this.baseUrl + `manufacturers/FindManufacturers`, model, {headers: httpHeaders, observe: 'response' });
}

GetManufacturerById(id: any) {
  let tokenString = '';
  const securityToken: string = localStorage.getItem('token');
  let httpHeaders = new HttpHeaders();
  if (securityToken != null) {
    tokenString = `Bearer ${securityToken}`;
    httpHeaders = new HttpHeaders()
      .set('authorization', tokenString)
      .set('Content-Type', 'application/json');
  } else {
    httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json');
  }
  return this.http.get(this.baseUrl + `manufacturers/ManufactuererById/` + id, {headers: httpHeaders});
}

GetManufacturerByName(names: string) {
  let tokenString = '';
  const securityToken: string = localStorage.getItem('token');
  let httpHeaders = new HttpHeaders();
  if (securityToken != null) {
    tokenString = `Bearer ${securityToken}`;
    httpHeaders = new HttpHeaders()
      .set('authorization', tokenString)
      .set('Content-Type', 'application/json');
  } else {
    httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json');
  }
  return this.http.get(this.baseUrl + 'manufacturers/ManufacturerNames/' + names, {headers: httpHeaders});
}

deleteManufacturer(id: number) {
  let tokenString = '';
  const securityToken: string = localStorage.getItem('token');
  let httpHeaders = new HttpHeaders();
  if (securityToken != null) {
    tokenString = `Bearer ${securityToken}`;
    httpHeaders = new HttpHeaders()
      .set('authorization', tokenString)
      .set('Content-Type', 'application/json');
  } else {
    httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json');
  }
  return this.http.delete(this.baseUrl + 'manufacturers/' + id, {headers: httpHeaders, observe: 'response'});
}

createManufacturer(model: any) {
  let tokenString = '';
  const securityToken: string = localStorage.getItem('token');
  let httpHeaders = new HttpHeaders();
  if (securityToken != null) {
    tokenString = `Bearer ${securityToken}`;
    httpHeaders = new HttpHeaders()
      .set('authorization', tokenString)
      .set('Content-Type', 'application/json');
  } else {
    httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json');
  }
  return this.http.post(this.baseUrl + 'manufacturers/create', model, {headers: httpHeaders, observe: 'response'});
}

UpdateManufacturers(id: any, model: any) {
  let tokenString = '';
  const securityToken: string = localStorage.getItem('token');
  let httpHeaders = new HttpHeaders();
  if (securityToken != null) {
    tokenString = `Bearer ${securityToken}`;
    httpHeaders = new HttpHeaders()
      .set('authorization', tokenString)
      .set('Content-Type', 'application/json');
  } else {
    httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json');
  }
  return this.http.put(this.baseUrl + `manufacturers/` + id, model, {headers: httpHeaders});
}

getManufacturer(id: number) {
  let tokenString = '';
    const securityToken: string = localStorage.getItem('token');
    let httpHeaders = new HttpHeaders();
    if (securityToken != null) {
      tokenString = `Bearer ${securityToken}`;
      httpHeaders = new HttpHeaders()
        .set('authorization', tokenString)
        .set('Content-Type', 'application/json');
    } else {
      httpHeaders = new HttpHeaders()
        .set('Content-Type', 'application/json');
    }
  return this.http.get(this.baseUrl + 'manufacturers/' + id, {headers: httpHeaders, observe: 'response' });
}
}
